import type { HomeLocales } from '@/types/lang/locales'

export const homeEn: HomeLocales = {
    announcementsTitle: 'Announcements',
}
